export default __webpack_public_path__ + "static/media/stellaj.c3893f14.png";